import { render, staticRenderFns } from "./BnUgyfelKivalaszt.vue?vue&type=template&id=6978e282&scoped=true&"
import script from "./BnUgyfelKivalaszt.vue?vue&type=script&lang=js&"
export * from "./BnUgyfelKivalaszt.vue?vue&type=script&lang=js&"
import style0 from "./BnUgyfelKivalaszt.vue?vue&type=style&index=0&id=6978e282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978e282",
  null
  
)

export default component.exports